export default function DownloadFile(blob: string, filename: string) {
  const source = "data:application/pdf;base64," + blob;
  const downloadLink = document.createElement("a");
  const fileName = `${filename}.pdf`;

  downloadLink.href = source;
  downloadLink.download = fileName;
  downloadLink.click();
}
